import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Container } from "react-bootstrap";
import Header2 from "../../components/Header2";
import { FiEdit } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css";
import { BiEditAlt } from "react-icons/bi";
import { useForm } from "react-hook-form";
import { IMAGE_URL } from "../../API";
import { toast } from "react-toastify";
import { ProfileContext } from "../../context/ProfileContext";
import avtar from "../../Assets/Images/image copy 2.png"
function EditProfile() {
  const { profile, editPersonalInfo, setCurrentImage, allDoctors } = useContext(ProfileContext);
  const navigate = useNavigate()
  const { register, handleSubmit, setValue, clearErrors, formState: { errors }, reset } = useForm();
  const [preview, setPreview] = useState(null);

  const loadFile = async (event) => {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    if (!event.target.files || event.target.files.length === 0) { toast.error("Please select a file."); return; }

    const file = event.target.files[0];
    if (!allowedTypes.includes(file.type)) { toast.error("Only JPG, PNG files are allowed."); setValue('file', null); return; }
    if (file.size > 20 * 1024 * 1024) { toast.error('File size should not exceed 20MB.'); setValue('file', null); return; }

    setCurrentImage(file)
    clearErrors('file');

    const imgUrl = URL.createObjectURL(file);
    setPreview(imgUrl);
  };

  useEffect(() => { if (profile && Object.keys(profile).length > 0) { reset(profile); } }, [profile, reset]);

  const handleRedirect = () => { navigate("/edit-basic-information") }

  const renderMedicalHistory = (keyName, profile) => {
    if (!keyName) return null;

    return Object.keys(keyName)
      .filter((key) =>
        (keyName[key] === true) ||
        (key === 'drug_use_frequency') ||
        (key === 'others' && keyName?.others_specify) ||
        (key === 'orthopedic_surgery' && keyName?.orthopedic_specify))
      .map((key, index, arr) => {
        let text = '';
        if (key === 'others' && keyName?.others_specify) { text = `${key.replace(/_/g, ' ')}: ${keyName.others_specify}` }
        else if (key === 'orthopedic_surgery' && keyName?.orthopedic_specify) { text = `${key.replace(/_/g, ' ')}: ${keyName.orthopedic_specify}` }
        else if (key === 'former_smoker' && profile?.quit_date) { text = `Former Smoker (Quit Date: ${new Date(profile.quit_date).toISOString().split('T')[0]})` }
        else if (key === 'drug_use_frequency' && keyName?.drug_use_frequency) { text = `Drug Use: ${keyName.drug_use_frequency} times/week` }
        else if (!['drug_use_weekly', 'drug_use_frequency'].includes(key)) { text = key.replace(/_/g, ' ') }
        else { return null }

        return (
          <h5 key={key}> {text} {index < arr.length - 1 ? ', ' : ''}</h5 >
        );
      });
  };


  return (
    <div className="comm_page_outer2">
      <Container>
        <Header2 />
        <div className="comm_inner_page_layout">
          <section className="comm_form_border_box_row">
            <div className="comm_border_box">
              <h4 className="comm_inner_form_heading">Edit profile</h4>
              <div className="profile_main_page">
                <div className="d-flex my_profile_row employer_logo_edit">
                  <div className="comm_profile_head_usr_detail">
                    <div className="profile-pic">
                      <label className="label" htmlFor="file">
                        <span className="glyphicon glyphicon-camera">
                          <BiEditAlt />
                        </span>
                      </label>
                      <input
                        id="file"
                        type="file"
                        name="profile_picture"
                        {...register('file')}
                        onChange={loadFile}
                      />
                      <figure className="profile-img-edit">
                        <img
                          src={preview ? preview : (profile.image ? `${IMAGE_URL}${profile.image}` : avtar)}
                          alt="Profile"
                          className="img-fluid"
                          onError={(e) => { e.target.onerror = null; e.target.src = avtar; }}
                        />
                      </figure>
                    </div>
                  </div>
                </div>
                <Form onSubmit={handleSubmit(editPersonalInfo)} className="comm_form">
                  <Row>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter Your Name" {...register('full_name', { required: 'Please enter name' })} />
                        {errors.full_name && <p className="error">{errors.full_name.message}</p>}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" disabled placeholder="Enter Your Email"
                          {...register('email', { required: 'Email is required', pattern: { message: 'Invalid email format', }, })}
                        />
                        {errors.email && <p className="error">{errors.email.message}</p>}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control type="text" placeholder="Number" {...register('number', { required: 'Please enter phone number.' })} />
                        {errors.number && <p className="error">{errors.number.message}</p>}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Address</Form.Label>
                        <Form.Control type="text" placeholder="Enter Your Address" {...register('address', { required: 'Please enter address.' })} />
                        {errors.address && <p className="error">{errors.address.message}</p>}
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="comm-pair-btns d-flex align-items-center gap-3">
                    <button type="submit" className="main-btn comm_icon_btn edit_profile_btn">Update changes</button>
                    <Link to="/profile" className="main-outline-btn">Discard changes</Link>
                  </div>
                </Form>
              </div>
            </div>
            {/* Basic information */}
            <div className="comm_border_box">
              <div className="d-flex comm_profile_top_head">
                <h4 className="comm_inner_form_heading">Basic Information</h4>
                <button onClick={handleRedirect} className="main-btn comm_icon_btn edit_profile_btn edit_profile_btn2">
                  <FiEdit /> Edit
                </button>
              </div>
              <div className="patient-age-name d-flex">
                <div className="patient-anme-view">
                  <p>DOB</p>
                  <h5>{profile.dob}</h5>
                </div>
                <div className="patient-anme-view">
                  <p>Blood Group</p>
                  <h5>{profile.blood_group}</h5>
                </div>
                <div className="patient-anme-view">
                  <p>Gender</p>
                  <h5>{profile.gender}</h5>
                </div>
                <div className="patient-anme-view">
                  <p>Age</p>
                  <h5>{profile?.age}</h5>
                </div>
                <div className="patient-anme-view">
                  <p>Height (cms)</p>
                  <h5>{profile.height}</h5>
                </div>
                <div className="patient-anme-view">
                  <p>Weight (kgs)</p>
                  <h5>{profile.weight}</h5>
                </div>
                <div className="patient-anme-view">
                  <p>Primary Care Provider</p>
                  <h5> {allDoctors.find(doc => doc._id === profile.primary_care_provider)?.name || "Not Assigned"}</h5>
                </div>
                <div className="patient-anme-view">
                  <p>Pharmacy</p>
                  <h5>{profile.pharmacy}</h5>
                </div>
              </div>
            </div>

            {/* Past Medical History */}
            <div className="comm_border_box">
              <div className="d-flex comm_profile_top_head single_prof_top_head">
                <h4 className="comm_inner_form_heading">Past Medical History</h4>
                <Link to="/edit-medical-history" className="main-btn comm_icon_btn edit_profile_btn edit_profile_btn2">
                  <FiEdit /> Edit
                </Link>
              </div>
              <div className="patient-age-name past_medical_history_view d-flex">
                <div className="patient-anme-view">
                  <p>Please check any condition you have or have had?</p>
                  {profile.no_medical_history ? (
                    <h5>No medical history</h5>
                  ) : (<h5>{renderMedicalHistory(profile.medical_history, profile)}</h5>)}
                </div>
                <div className="patient-anme-view">
                  <h4 className="comm_inner_form_heading">Past Surgical History</h4>
                  <p>Please check any surgery you have had?</p>
                  {profile.never_had_surgery ? (
                    <h5>never had  surgery</h5>
                  ) : (<h5>{renderMedicalHistory(profile.surgical_history, profile)}</h5>)}
                </div>
                <div className="patient-anme-view">
                  <h4 className="comm_inner_form_heading">Social History</h4>
                  <div className="patient-anme-view-inner">
                    <div>
                      <p>Please check for smoking pattern.</p>
                      {profile.never_smoker ? (
                        <h5>No Smoking</h5>
                      ) : (<h5>{renderMedicalHistory(profile.social_history, profile)}</h5>)}
                    </div>
                    <div>
                      <p>Please check for drink/alcohol pattern.</p>
                      {profile.non_alcoholic ? (
                        <h5>non alcoholic</h5>
                      ) : (<h5>{renderMedicalHistory(profile.alcohol_history, profile)}</h5>)}

                    </div>
                    <div>
                      <p>Please check for drug pattern.</p>
                      {profile.non_druggist ? (
                        <h5>No drugs</h5>
                      ) : (<h5>{renderMedicalHistory(profile.drug_history, profile)}</h5>)}
                    </div>
                  </div>
                </div>
                <div className="patient-anme-view">
                  <h4 className="comm_inner_form_heading">Family History</h4>
                  <p>Please write in any medical condition or disease that has been in your family</p>
                  {profile?.family_history?.map((field, index) => (
                    <h5 key={index}>
                      {field.family_member} had {field.disease}
                    </h5>
                  ))}
                </div>
                <div className="patient-anme-view">
                  <h4 className="comm_inner_form_heading">Current Medications</h4>
                  {profile.no_medication ? (<h5>No current mediactions</h5>) :
                    (profile?.current_medications?.map((field, index) => (
                      <h5 key={index}>
                        Medication: {field.medication},
                        Strength (Dose): {field.strength},
                        frequency :{field.frequency}
                      </h5>
                    )))}
                </div>
                <div className="patient-anme-view">
                  <h4 className="comm_inner_form_heading">Medication Allergies</h4>
                  {profile.no_medication_allergy ? (
                    <h5>No known medication allergies</h5>
                  ) : (
                    profile?.medication_allergy?.map((field, index) => (
                      <h5 key={index}>
                        Medication: {field.medication},
                        Reaction: {field.reaction},
                      </h5>
                    ))
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </Container>
    </div>
  );
}

export default EditProfile;
